import React, { useEffect, useRef } from 'react';

const CANVAS_WIDTH = 90;
const CANVAS_HEIGHT = 90;
const PADDING = 4;

const flattenCoordinates = (coordinates = []) => {
  if (!Array.isArray(coordinates)) return [];
  const points = [];

  const walk = (node) => {
    if (!Array.isArray(node)) return;
    if (typeof node[0] === 'number' && typeof node[1] === 'number') {
      points.push({ lat: node[0], lng: node[1] });
      return;
    }
    node.forEach(walk);
  };

  walk(coordinates);
  return points;
};

const TaskingStripThumbnail = ({ coordinates, color = '#76b6ff' }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !coordinates || coordinates.length === 0) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const points = flattenCoordinates(coordinates);
    if (points.length === 0) {
      ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
      return;
    }

    const lats = points.map((p) => p.lat);
    const lngs = points.map((p) => p.lng);
    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLng = Math.min(...lngs);
    const maxLng = Math.max(...lngs);

    const latRange = maxLat - minLat || 1;
    const lngRange = maxLng - minLng || 1;

    ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

    const gradient = ctx.createLinearGradient(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
    gradient.addColorStop(0, '#2b2f3a');
    gradient.addColorStop(1, '#1c1f26');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

    ctx.beginPath();
    points.forEach((point, index) => {
      const x =
        PADDING + ((point.lng - minLng) / lngRange) * (CANVAS_WIDTH - PADDING * 2);
      const y =
        PADDING +
        (1 - (point.lat - minLat) / latRange) * (CANVAS_HEIGHT - PADDING * 2);

      if (index === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    });
    ctx.closePath();
    ctx.fillStyle = `${color}40`;
    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.fill();
    ctx.stroke();
  }, [coordinates]);

  return (
    <canvas
      ref={canvasRef}
      width={CANVAS_WIDTH}
      height={CANVAS_HEIGHT}
      style={{
        width: CANVAS_WIDTH,
        height: CANVAS_HEIGHT,
        objectFit: 'cover',
        borderRadius: 0,
        display: 'block',
      }}
    />
  );
};

export default TaskingStripThumbnail;

